var _path, _path2, _g, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgFuneralHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_17970",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_17970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2701 11.9753C57.2701 11.9753 70.1073 13.9 69.1076 28.6577C68.1085 43.4137 79.445 38.4433 80.1134 48.3876C80.7789 58.3331 83.1656 55.6219 85 63.0002C86.835 70.3796 81.6642 75.9909 78.3297 79.0395C74.9963 82.0876 33.4258 94.2617 21.4232 77.2577C9.41651 60.2538 20.588 50.4693 24.0888 47.2614C27.5902 44.0534 31.5902 41.1658 26.9241 36.1942C22.2532 31.2203 29.5926 26.8895 30.7585 26.5697C31.9268 26.2487 30.6427 19.6084 36.3092 14.7962C41.981 9.98448 48.8498 8.33712 57.2701 11.9753Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7077 51.1672H57.6473V48.5732H42.1V51.1645C42.1 53.703 42.0894 56.4623 39.8789 58.1314V82.9996H49.8737C49.8737 82.9996 55.1072 82.9996 59.8684 82.9996V58.0926C57.7145 56.4193 57.7077 53.6839 57.7077 51.1672Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8741 74.4122C46.5682 74.4122 42.3948 71.7108 40.373 70.2954L43.2109 103H58.7582V70.2954C56.2389 72.8834 53.18 74.4122 49.8741 74.4122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 64.8361L41 63L50 74.377L48.5 79L34 64.8361Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 64.8361L59 63L50 74.377L51.5 79L66 64.8361Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7575 63.0112C59.1627 63.1218 59.5276 63.1807 59.868 63.2093V58.0937C57.7142 56.4204 57.7073 53.6849 57.7073 51.1681L57.7058 51.1037V48.5098L45.4312 48.5742L42.0996 49.6847C44.3207 52.1836 51.1228 60.929 58.7575 63.0112Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4207 34.1358C65.4207 43.029 56.5761 54.1253 49.8735 54.1253C43.1708 54.1253 34.3262 43.029 34.3262 34.1358C34.3262 25.2426 41.287 21.9199 49.8735 21.9199C58.4599 21.9199 65.4207 25.2426 65.4207 34.1358Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5 32C68 34.5 67 36.5 66.5 38.5C66.1 40.1 64 40.8333 63 41V32.5C63.6667 31.5 65.3 30 66.5 32Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7919 32.0164C31.2926 34.5941 32.2921 36.6562 32.7919 38.7183C33.1916 40.368 35.2906 41.1242 36.29 41.296V32.532C35.6237 31.5009 33.9912 29.9543 32.7919 32.0164Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.426 23.0306C57.462 30.3415 61.5339 33.65 65.3514 34.6217C67.4432 35.1542 68.5314 29.5833 68.5314 29.5833C68.5314 29.5833 63.5699 20.9946 63.1998 20.8097C62.8297 20.6245 59.8682 14.1465 59.8682 14.1465L53.2051 19.6992L55.426 23.0306Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 26.0002C43 37.5002 36 38.1668 32 39.5002V30.0002L38.5 20.5002C41.3333 19.6668 48 17.6002 52 16.0002C56 14.4002 57.3333 20.0002 57.5 23.0002C55 21.8335 48.8815 20.5909 47 26.0002Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6373 56.8013C39.5176 58.4911 37.2347 59.679 32.5497 59.679H32.1512C24.8881 59.679 19 65.1482 19 71.8949V99.6686C19 101.508 20.6058 103 22.5867 103H47L40.6373 56.8013Z",
    fill: "#B7B7B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 58.5C38 62 35.3003 69.2 38.5003 76C35.5002 85.5 38.5002 88 46.0002 104.5",
    stroke: "#939296"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1104 56.8013C60.2301 58.4911 62.513 59.679 67.198 59.679H67.5964C74.8595 59.679 80.7477 65.1482 80.7477 71.8949V99.6686C80.7477 101.508 79.1419 103 77.161 103H53L59.1104 56.8013Z",
    fill: "#B7B7B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0227 59C62.0232 62.4163 64.7236 69.4441 61.5228 76.0815C64.5236 85.3543 61.5229 87.7946 54.021 103.9",
    stroke: "#939296"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7515 3.60331C86.1257 -0.325702 79.6307 1.64228 79.6307 1.64228L79.575 1.684C77.2792 2.28272 75.2424 3.61619 73.7754 5.48089L74.749 27.0383H89.7696L90.3815 5.11233L91.7515 3.60331Z",
    fill: "#787B7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.164 27.0662L77.1904 5.50879C77.1904 5.50879 83.449 -3.14894 93.4697 4.81339C93.5786 4.91075 93.6808 5.01529 93.7757 5.12632L92.4336 27.0662H78.164Z",
    fill: "#4B4A50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4518 7.50391H84.8594V16.1477H86.4518V7.50391Z",
    fill: "#B7B7B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5946 10.1479H82.6768V11.7404H88.5946V10.1479Z",
    fill: "#B7B7B9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFuneralHome);
export default __webpack_public_path__ + "static/media/imgFuneralHome.81d4e6cff93c7f859d464875022c7a4b.svg";
export { ForwardRef as ReactComponent };